import {AutomationOutputFileConfigGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileConfigGraphQL';
import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';

export function isFolderRequiredForOutputFile(
  automationOutputFileConfig: AutomationOutputFileConfigGraphQL
): boolean {
  const tagSchemaInfo = automationOutputFileConfig.tagSchemaInfo;
  if (
    tagSchemaInfo != null &&
    // sourceId/folderId is not present in configs versioned before per-file folder selection
    // but we don't want to show folder picker for those configs
    tagSchemaInfo.hasOwnProperty('sourceId') &&
    tagSchemaInfo.hasOwnProperty('folder') &&
    tagSchemaInfo.sourceId == null &&
    tagSchemaInfo.folder?.id == null
  ) {
    return true;
  }
  const destinationInfo = automationOutputFileConfig.destinationInfo;
  if (destinationInfo != null && destinationInfo.sourceId == null) {
    return true;
  }
  return false;
}

export function isLocationRequiredForOutputFile(
  automationOutputFileConfig: AutomationOutputFileConfigGraphQL
): boolean {
  const destinationInfo = automationOutputFileConfig.destinationInfo;
  return destinationInfo != null && destinationInfo.location?.id == null;
}

export function isOutputFileMissingFolder(automationOutputFile: AutomationOutputFileGraphQL): boolean {
  return (
    isFolderRequiredForOutputFile(automationOutputFile.automationOutputFileConfig) &&
    !automationOutputFile.folderId
  );
}

export function isOutputFileMissingLocation(automationOutputFile: AutomationOutputFileGraphQL): boolean {
  return (
    isLocationRequiredForOutputFile(automationOutputFile.automationOutputFileConfig) &&
    !automationOutputFile.locationId
  );
}

export function isOutputFileMissingFolderOrLocation(
  automationOutputFile: AutomationOutputFileGraphQL
): boolean {
  return isOutputFileMissingFolder(automationOutputFile) || isOutputFileMissingLocation(automationOutputFile);
}
